var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.32995 16.4543V17.6689V4.33138V16.4543ZM19.8445 7.19596H17.6674V4.33138H4.32995V17.6689H17.6674V14.8272H19.8445V19.823H2.17578V2.1543H19.8445V7.19596ZM10.632 15.2855V6.73763H20.807V15.2855H10.632ZM14.9459 12.4668C15.3547 12.4668 15.7004 12.322 15.9831 12.0323C16.2657 11.7426 16.407 11.3909 16.407 10.9772C16.407 10.5762 16.2619 10.2352 15.9716 9.95444C15.6813 9.67379 15.3376 9.53346 14.9404 9.53346C14.5431 9.53346 14.1994 9.67379 13.9091 9.95444C13.6188 10.2352 13.4737 10.5762 13.4737 10.9772C13.4737 11.3909 13.6169 11.7426 13.9032 12.0323C14.1893 12.322 14.5369 12.4668 14.9459 12.4668ZM19.432 13.9105V8.11263H12.007V13.9105H19.432Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.72b74b5da79299d0581a891be9ad8dd0.svg";
export { ForwardRef as ReactComponent };